import React, { useEffect, useRef, useState } from 'react';
import Popup from 'reactjs-popup';
import { Link } from 'react-router-dom';

const RenamePopup = ({ openModal, setOpen, title, onCategoryUpdate }) => {
  const closeModal = () => setOpen(false);
  const [updateCategory, setUpdateCategory] = useState('');
  const [error, setError] = useState('');
  const inputRef = useRef(null);

  useEffect(() => {
    if (openModal) {
      setUpdateCategory(title);
      setError('');
      const timer = setTimeout(() => {
        inputRef.current?.focus();
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [openModal, title]);

  const handleCategoryUpdate = async (e) => {
    e.preventDefault();
    if (!updateCategory.trim()) {
      setError('Category name cannot be empty.');
      return;
    }
    if (updateCategory.trim() === title) {
      setError('No changes detected.');
      return;
    }

   const response = await onCategoryUpdate(updateCategory.trim());
   if(response){
        closeModal();
   }
  };

  return (
    <div>
      <Popup open={openModal} closeOnDocumentClick onClose={closeModal} lockScroll={true}>
        <div className="modal">
          <div className="modal-header">
            <h3>Rename</h3>
            <Link className="close" onClick={closeModal}>
              &times;
            </Link>
          </div>
          <div className="modal-content">
            <form onSubmit={handleCategoryUpdate}>
              <div className="form-group">
                <label>Category name</label>
                <input
                  name="add_new_category"
                  placeholder="e.g. Team"
                  ref={inputRef}
                  value={updateCategory}
                  onChange={(e) => {
                    setUpdateCategory(e.target.value);
                    setError('');
                  }}
                />
              </div>
              {error && <p className="error">{error}</p>}
              <div className="text-right">
                <button type="submit" className="btn btn-submit">
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default RenamePopup;
